import { LAMINATE_REGEX } from '@common/constants/MaterialType-Constants';
import { BACKSPLASH_DEFAULT_VALUE, WATERFALL_DEFAULT_VALUE } from '@common/constants/constants';
import { SideItemType } from '@common/enums';
import { SideItemInfoModel } from '@common/models';

/**
 * this is the default/base list of side item records (partial!) from which
 * the real ones get built by MultiSideItems.tsx
 */
export const DEFAULT_SIDE_ITEMS: Partial<SideItemInfoModel>[] = [
    {
        id: 1,
        sideType: SideItemType.WALL_SIDE,
        checked: false,
        disabled: false,
        backsplash: {
            checked: false,
            height: BACKSPLASH_DEFAULT_VALUE,
        },
    },
    {
        id: 2,
        sideType: SideItemType.APPLIANCE_SIDE,
        checked: false,
        disabled: false,
    },
    {
        id: 3,
        sideType: SideItemType.WATERFALL,
        checked: false,
        disabled: false,
        waterfallHeight: WATERFALL_DEFAULT_VALUE,
    },
    {
        id: 4,
        sideType: SideItemType.END_CAP,
        checked: false,
        disabled: false,
        materialFilter: LAMINATE_REGEX,
    },
    {
        id: 5,
        sideType: SideItemType.END_SPLASH,
        checked: false,
        disabled: false,
        materialFilter: LAMINATE_REGEX,
    },
];
